export default __webpack_public_path__ + "media/images/border-left2-0608aa4d9ee992cb03ab88903a935d4e.png";